import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

import en from "./en";
import fi from "./fi";
import sv from "./sv";

const dateTimeFormat = {
    date: { year: "numeric", month: "long", day: "numeric", hour12: false },
    time: { hour: "numeric", minute: "numeric", second: "numeric", hour12: false },
    full: {
        year: "numeric", month: "long", day: "numeric",
        hour: "numeric", minute: "numeric", second: "numeric", hour12: false
    }
};

const numberFormat = {
    currency: { style: "currency", currency: "EUR" }
};

export default new VueI18n({
    locale: "en",
    fallbackLocale: "en",
    messages: { en, fi, sv },
    dateTimeFormats: {
        en: dateTimeFormat,
        fi: dateTimeFormat,
        sv: dateTimeFormat,
    },
    numberFormats: {
        en: numberFormat,
        fi: numberFormat,
        sv: numberFormat,
    },
});
